import { BarChart3 } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { ReportRoutes } from "./routes";
import { ReportPermissions } from "./permissions";

export const reportNav: INavItem = {
  labelKey: "nav.reports",
  icon: BarChart3,
  path: ReportRoutes.INDEX,
  permissions: [ReportPermissions.READ],
};
